import { render, staticRenderFns } from "./SetBulkExpiration.vue?vue&type=template&id=d1992e0e"
import script from "./SetBulkExpiration.vue?vue&type=script&lang=js"
export * from "./SetBulkExpiration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports